import { Box } from '@mui/material';
import { GuestJourneyDetailsCards } from 'api/reports-service/guest-journey-reports.types';
import KpiCard from '../kpi-card/kpi-card.component';

export type DetailsSummaryCardsProps = {
  data?: GuestJourneyDetailsCards;
  loading?: boolean;
};

/**
 * Card order is an FE decision — the BE response is keyed by metric name.
 * Titles (which reference the settings-driven tier names) and values arrive
 * pre-formatted on the cards.
 */
const CARD_ORDER: (keyof GuestJourneyDetailsCards)[] = [
  'percentExplorers',
  'percentRegulars',
  'percentSuperfans',
  'percentValue',
  'percentCore',
  'percentIndulgent',
];

const DetailsSummaryCards = ({
  data,
  loading = false,
}: DetailsSummaryCardsProps) => {
  const cards = CARD_ORDER.map(id => [id, data?.[id]] as const).filter(
    ([, card]) => card,
  );

  return (
    <Box
      display="grid"
      gap={2}
      gridTemplateColumns={{
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
        lg: 'repeat(6, 1fr)',
      }}
      data-testid="Details.SummaryCards"
    >
      {cards.map(([id, card]) => (
        <KpiCard
          key={id}
          card={card}
          loading={loading}
          data-testid={`Details.SummaryCard.${id}`}
        />
      ))}
    </Box>
  );
};

export default DetailsSummaryCards;
